import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../index.css";
import { Helmet } from "react-helmet";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

export default function NotFound() {


    return (
        <div className="main justify-center">
            <Helmet>
                <title>404-Error</title>
            </Helmet>
            <div className="flex-col items-center">
                <div className="massive font-semibold">You seem lost</div>
                <div>This page does not exist. Let me take you back.</div>
                <Link to="/" style={{backgroundColor: "var(--green)", color: "var(--white)", padding: "7px 30px", borderRadius: "50px", marginTop: "20px"}}>Home <FontAwesomeIcon className="small" icon={faChevronRight}/></Link>
            </div>
        </div>
    );
}